/**
 * @ngdoc directive
 * @name vInclude
 * This handles include html components
 */

import extend from "../../services/extend";

export default (vue) => extend(vue, (vue) => {
    return {
        slug: null,
        init() {
            this.slug = 'template.' + vue.exp.replace(/[\/\.\-]/g,'_');
            if ( typeof vue.get(this.slug) === 'undefined') {
                fetch(vue.exp)
                    .then((response) => {
                        return response.text();
                    })
                    .then((html) => {
                        vue.set(this.slug, html);
                        vue.el.innerHTML = html;
                        setTimeout(() => {
                            app.mount(vue.el.firstChild);
                        }, 50 );
                    })
                    .catch();
            } else {
                vue.el.innerHTML = vue.get(this.slug);
                setTimeout(() => {
                    app.mount(vue.el.firstChild);
                }, 50 )
            }
        },
    }

});




